import { Component, OnInit, AfterViewInit, ViewChild, Renderer2 } from '@angular/core';
import { DashboardService } from '@teem/services/dashboard.service';
import { AddClientModalComponent } from '@teem/clients-module/modals/add-client-modal/add-client-modal.component';
import { OrderService } from '@teem/core/services/order.service';
import { LoaderService } from '@teem/core/services/loader.service';
import { data } from 'jquery';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TeemappTableComponent } from '@teem/app/shared';
import { ACTIONS as ORDER_ACTIONS } from '@teem/constants/order';
import Swal from 'sweetalert2';
import { messages as i18n } from '@teem/constants/messages';
import { CurrentOrdersComponent } from '@teem/features/dashboard/components/current-orders/current-orders.component';
import { InvoiceService } from '@teem/services/invoice.service';
import { Invoice } from '@teem/app/core/models/invoice';
import { UserService } from '@teem/services/user.service';
import { SharedDataService } from '@teem/services/shared-data.service';
import { ACTIONS as INVOICE_ACTIONS } from '@teem/constants/invoice';
declare var $;

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, AfterViewInit {
    @ViewChild('clientsTableRef') clientsTableRef: TeemappTableComponent;
    @ViewChild(CurrentOrdersComponent) CurrentOrdersComponent: CurrentOrdersComponent;
    @ViewChild('invoicesTableRef') invoicesTableRef: TeemappTableComponent;
    activeTab: string = 'dashboard';
    activeInvoice: any;
    showPendingSteps = '';
    userName = '';
    businessType = '';
    subscriptionPlan = '';
    isRequiredCompleted = '';
    showPendingStepCards: any = [];
    percentage = '';
    params: any = {};
    selectedOrderType: string = 'all';
    userInfo: any;
    triggerInvoice: boolean = false;
    allInvoices: any;
    closedInvoices: any;
    pendingInvoices: any;
    permissions: any;
    shopLink:any;
    constructor(
        private invoiceService: InvoiceService,
        private orderService: OrderService,
        private modalService: NgbModal,
        private loaderService: LoaderService,
        private dashboardService: DashboardService,
        private userService:UserService,
        private sharedDataService:SharedDataService,
        private renderer: Renderer2
    ) {

    }

    ngOnInit(): void {
        this.loaderService.startLoading();
        this.dashboardService.getpendingSteps().subscribe((response: any = []) => {
            this.showPendingSteps = response.pendingSteps;
            this.userName = response.userName;
            this.isRequiredCompleted = response.isRequiredCompleted;
            this.showPendingStepCards = response.pendingStepCards;
            this.percentage = response.percentage;
            this.businessType = response.businessType
            this.subscriptionPlan = response.subscriptionPlan
            this.loaderService.stopLoading();
            this.shopLink = response.shopUrl;
        });

        this.sharedDataService.asObservable().subscribe((data) => {
            if (data) {
              if (data.userInfo) {
                // Survicate.init({
                //   workspaceKey: environment?.survicate_key,
                //   disableTargeting: true,
                //   traits: {
                //     id: data.userInfo.id,
                //     email: data.userInfo.email
                //   }
                // });
                this.userInfo = data.userInfo
                // let addOnlinePaymentMenu: any = this.invoiceMenuItems.find(menu => menu.key == "add_online_payment");
                // addOnlinePaymentMenu.visible = data.userInfo && data.userInfo.halala_mobile;
              }
      
              if (data.permissions) {
                this.permissions = data.permissions;
              }
            }
        })
    }
    ngAfterViewInit(): void {
        // this.loaderService.stopLoading();
    }

    openAddClientModal() {
        const modalRef = this.modalService.open(AddClientModalComponent);
    
        // Set id on modal dialog
        modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.id = "newClient";
    
        modalRef.result.then(result => {
          this.clientsTableRef.getPage(1);
        }, fallbackResult => {
          // do nothing
        })
    }

    visitStore(){
      window.location.href = this.shopLink;
    }

    toggleDropdown(event: Event): void {
      const button = event.target as HTMLElement;
      const dropdownContainer = button.closest('.custom_select');
      const dropdownMenu = dropdownContainer.querySelector('.custom_select-content');
      const allDropdowns = document.querySelectorAll('.custom_select-content');
      const allContainers = document.querySelectorAll('.custom_select');
  
      allDropdowns.forEach((dropdown) => {
        if (dropdown !== dropdownMenu) {
          this.renderer.setStyle(dropdown, 'display', 'none');
        }
      });
  
      allContainers.forEach((container) => {
        if (container !== dropdownContainer) {
          this.renderer.removeClass(container, 'active');
        }
      });
  
      const isDropdownVisible = dropdownMenu.getAttribute('style') === 'display: block;';
  
      this.renderer.setStyle(dropdownMenu, 'display', isDropdownVisible ? 'none' : 'block');
  
      if (isDropdownVisible) {
        this.renderer.removeClass(dropdownContainer, 'active');
      } else {
        this.renderer.addClass(dropdownContainer, 'active');
      }
    }

    orderAction(obj: any) {
        switch (obj.action) {
            case "accept":
                this.markAsAccept(obj);
                break;
            case "cancel":
                this.markAsCancel(obj.uuid);
                break;
            case "rejected":
                this.markAsRejectedWithReason(obj);
                break;
            case "accept_selected":
                this.markAsAcceptSelected(obj);
                break;
            case "edit_invoice":
                this.onEditInvoice([obj.uuid]);
                break;
        }
    }

    markAsAccept(obj: any) {
        console.log(obj)
        if (obj) {
            this.loaderService.startLoading();
            this.orderService.action({ 'do': ORDER_ACTIONS.MARK_AS_ACCEPT, 'uuid': obj.uuid }).subscribe(data => {
                Swal.fire('', i18n.order.marked_as_accepted, 'success');
                this.params.order_type = this.selectedOrderType;
                this.loaderService.stopLoading();
                this.CurrentOrdersComponent.getCurrentOrders();
            }, err => {
                this.loaderService.stopLoading();
                Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
            });
        }
    }

    markAsAcceptSelected(obj: any) {
        if (obj) {
            this.loaderService.startLoading();
            this.orderService.action({ 'do': ORDER_ACTIONS.MARK_AS_ACCEPT_SELECTED, 'uuid': obj.uuid }).subscribe(data => {
                Swal.fire('', i18n.order.marked_as_accepted, 'success');
                this.params.order_type = this.selectedOrderType;
                this.loaderService.stopLoading();
                this.CurrentOrdersComponent.getCurrentOrders();
            }, err => {
                this.loaderService.stopLoading();
                Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
            });
        }
    }

    markAsCancel(selected: any) {
        if (selected.length) {
            this.loaderService.startLoading();
            this.orderService.action({ 'do': ORDER_ACTIONS.MARK_AS_CANCELED, 'uuid': selected }).subscribe(data => {
                Swal.fire('', i18n.order.marked_as_canceled, 'success');
                this.params.order_type = this.selectedOrderType;
                this.loaderService.stopLoading();
                this.CurrentOrdersComponent.getCurrentOrders();
            }, err => {
                this.loaderService.stopLoading();
                Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
            });
        }
    }

    markAsRejectedWithReason(obj: any) {
        if (obj) {
            this.loaderService.startLoading();
            this.orderService.action({ 'do': obj.action, 'uuid': obj.uuid, 'reason': obj.rejected_reason }).subscribe(data => {
            Swal.fire('', i18n.order.marked_as_rejected, 'success');
            this.params.order_type = this.selectedOrderType;
            this.loaderService.stopLoading();
            this.CurrentOrdersComponent.getCurrentOrders();
            }, err => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
            });
        }
    }

    switchTab() {
        this.activeTab = "dashboard";
    }

    onEditInvoice(selectedInvoices: Array<string>) {
        if (selectedInvoices.length === 1) {
          this.loaderService.startLoading();
          this.invoiceService.get(selectedInvoices[0]).subscribe((invoice: Invoice) => {
            this.activeInvoice = invoice;
            this.activeTab = "edit-invoice";
            this.loaderService.stopLoading();
          }, err => {
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
            this.loaderService.stopLoading();
          })
        }
    }

    onSubmitEditInvoice(data: any) {
        this.loadCommonData();
        this.fetchPermissions();
        this.activeTab = 'dashboard';
        setTimeout(() => {
          $('#tab-links-select[nice-select]').niceSelect('update');
        }, 100);
    }
    
    onDeleteInvoice(invoice: Invoice) {
        this.deleteInvoices([invoice.uuid]);
    }

    loadCommonData() {
        this.invoiceService.stats().subscribe((data: any) => {
          if (data.all == 0) {
            this.triggerInvoice = true;
          }
          this.allInvoices = data.total;
          this.closedInvoices = data.closed;
          this.pendingInvoices = data.pending;
        })
      }
    
      fetchPermissions() {
        this.userService.getPermissions().subscribe((data: any) => {
          if (data) {
            this.sharedDataService.setItem('permissions', data);
          }
        });
      }

      deleteInvoices(selectedInvoices: Array<string>) {
          if (selectedInvoices.length) {
            Swal.fire({
              title: i18n.are_you_sure,
              text: i18n.invoice.you_want_to_delete_invoice,
              icon: 'info',
              showCloseButton: true,
              showCancelButton: true,
              focusConfirm: false,
              confirmButtonText:
                i18n.yes,
              cancelButtonText:
                i18n.no_cancel_it
            }).then(result => {
              if (result.value) {
      
                this.loaderService.startLoading();
      
                this.invoiceService.action({ 'do': INVOICE_ACTIONS.DELETE, 'ids': selectedInvoices }).subscribe(data => {
                  this.loaderService.stopLoading();
                  this.invoicesTableRef.getPage(1);
      
                  // if (this.activeTab == 'all-invoices') {
                  //   this.invoicesTableRef.getPage(1);
                  // } else if (this.activeTab == 'drafts') {
                  //   this.draftsTableRef.getPage(1);
                  // } else {
                  //   this.activeTab = 'all-invoices';
                  //   this.invoicesTableRef.getPage(1);
                  //   this.draftsTableRef.getPage(1);
                  // }
      
                  Swal.fire(i18n.deleted, selectedInvoices.length == 1 ? i18n.invoice.invoice_deleted : i18n.invoice.invoices_deleted, 'success');
      
                  this.loadCommonData();
                  this.fetchPermissions();
      
                }, err => {
                  this.loaderService.stopLoading();
                  Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
                });
              }
            });
          }
        }
}